import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "./hooks/auth_context";
import { signOutUser } from "./firebase_auth/firebase_auth";
import LoadingPage from "./components/Loading";

const ProtectedRoute = ({ Element }: { Element: any }) => {
  const { currentUser, isLoading, isLoggedIn } = useAuth();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (currentUser.typeUser === "admin" && isLoggedIn) {
    return <>{Element}</>;
  } else if (currentUser.typeUser === "user") {
    signOutUser();
    return <Navigate to="/unauthorized" replace />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;
